import React, {Component} from 'react';
import Interceptors from '../components/utils/interceptors';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {ConnectedRouter} from 'connected-react-router'
import {Provider} from 'react-redux';
import './application.css';
import 'bootstrap/dist/js/bootstrap';
import 'react-notifications/lib/notifications.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'velocity-animate';
import configureStore, {history} from '../components/store/configureStore';

import LoginWithDomain from '../components/components/containers/LoginWithDomain';
import ErrorBoundary from '../components/components/containers/ErrorBoundary';

export default class Setup extends Component {
  render() {
    const { store, history } = this.props;
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <SetupPage />
        </ConnectedRouter>
      </Provider>
    );
  }
}

Setup.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

const store = configureStore();
Interceptors.setupInterceptors(store);

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <ErrorBoundary>
      <LoginWithDomain store={store} history={history} />
    </ErrorBoundary>,
    document.getElementById('login')
  )
});
